;(function() {
  "use strict"

  angular.module("UP").directive("uniDatepicker", [
    "$timeout",
    function($timeout) {
      return {
        restrict: "A",
        scope: true,
        require: "?ngModel",

        link: function(scope, element, attrs, ngModel) {
          scope.formato = attrs.dateFormat || "dd/mm/yyyy"
          var $el = $(element)

          ngModel.$render = function() {
            var modelValue = ngModel.$modelValue

            if (!scope.init) {
              var $e = $el.datepicker({
                autoclose: true,
                language: "es",
                lang: "es",
                format: scope.formato,
              })

              $e.on("changeDate", function(event) {
                scope.$apply(function() {
                  setTimeout(function() {
                    ngModel.$setViewValue(event.date)
                  })
                })
              })

              $e.on("blur", function(event) {
                // console.log('blur', event);

                // console.log($el.datepicker('getDate'));

                var date = $el.datepicker("getDate")
                // ngModel.$setViewValue( elemen;

                // solo actualziar si hay un cambio
                if (!date || date.valueOf() != ngModel.$viewValue.valueOf())
                  ngModel.$setViewValue(date)
              })

              ngModel.$setPristine()

              console.log("pristine", ngModel.$pristine)

              scope.init = true
            }

            var current = $el.datepicker("getDate")
            if (current || modelValue) {
              // si ya había algo o si hay
              // algo nuevo

              var d
              if (typeof modelValue === "string") {
                // es iso string ?
                if (modelValue.match(/Z$/)) {
                  try {
                    d = new Date(modelValue)

                    console.log("Fecha es un isostring")
                  } catch (error) {
                    console.log("No se puede parsear fecha como iso string")
                  }
                }

                if (!d) {
                  var f =
                    modelValue.length > 4 && modelValue.charAt(4) === "-"
                      ? "yyyy-mm-dd"
                      : scope.formato
                  d = $.prototype.datepicker.DPGlobal.parseDate(modelValue, f)
                }
              } else if (modelValue) {
                d =
                  typeof modelValue === "object"
                    ? modelValue
                    : new Date(modelValue)
              }

              // si no se saca fecha pero existía algo o es alguna
              // fecha (esto no debería pasar)
              if (!d && (current || modelValue)) {
                $el.datepicker("update", d)
                ngModel.$setViewValue(d)
              } else if (d) {
                d.setHours(0, 0, 0, 0)

                if (!current || d.valueOf() != current.valueOf()) {
                  $el.datepicker("update", d)

                  ngModel.$setViewValue(d)
                  ngModel.$setPristine()
                }
              }
            }
          }
        },
      }
    },
  ])

  angular.module("UP").directive("uniDatepickerDebug", [
    "$timeout",
    function($timeout) {
      return {
        restrict: "A",
        // Always use along with an ng-model
        scope: true,
        require: "?ngModel",

        link: function(scope, element, attrs, ngModel) {
          var $el = $(element)
          this.dateFormat

          console.log(scope)

          console.log(ngModel)

          // if (true)
          // $timeout (function () {

          scope.$watch(attrs.ngModel, function(old, val) {
            console.log("***** " + val + "," + old)
          })

          console.log("datepicker " + ngModel.$modelValue)

          ngModel.$render = function() {
            // This will update the view with your model in case
            // your model is changed by another code.

            console.log("-------- render: ", ngModel.$modelValue)

            console.log("** " + scope.inicializado)

            var modelValue = ngModel.$modelValue

            if (!$el.data("init")) {
              $el
                .datepicker({
                  autoclose: true,
                  language: "es",
                  lang: "es",
                  format: attrs.dateFormat || "dd/mm/yyyy",
                })
                .on("changeDate", function(event) {
                  console.log("event: ", event)
                  console.log("event.date : ", event.date)

                  scope.$apply(function() {
                    setTimeout(function() {
                      ngModel.$setViewValue(event.date)
                    })
                  })
                })
                .on("blur", function(event) {
                  console.log("blur", event)

                  console.log($el.datepicker("getDate"))

                  var date = $el.datepicker("getDate")
                  // ngModel.$setViewValue( elemen;

                  ngModel.$setViewValue(date)
                })

              $el.data("init", true)
            }

            if (modelValue && modelValue != ngModel.$viewValue) {
              var d

              if (typeof modelValue === "string") {
                d = $.prototype.datepicker.DPGlobal.parseDate(
                  modelValue,
                  "dd/mm/yyyy"
                )
              } else {
                d =
                  typeof modelValue === "object"
                    ? modelValue
                    : new Date(modelValue)
              }

              d.setHours(0, 0, 0, 0)

              console.log(
                "Cambiando fecha a ",
                d,
                modelValue,
                "-" + typeof modelValue + "-"
              )

              // $el.datepicker('setDate', d);
              $el.datepicker("update", d)
              // ngModel.$modelValue = d;
              $timeout(function() {
                // scope.$apply(function() {
                ngModel.$setViewValue(d)
              })
              // });
            }
          }

          // }, 0);
        },
      }
    },
  ])
})()
